import React from 'react';

export const LinkArrowIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="link-arrow"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.68109 1.36488L0 1.36488L0 0L12 0V12H10.7433L10.6571 2.30296L0.975992 12L0 11.0619L9.68109 1.36488Z"
      fill="currentColor"
    />
  </svg>
);
